module.exports = __webpack_public_path__ + "static/avatar-15ace5ea280723f35078eac6a37c2a40.png";